import {
  StyledHomeContent,
  StyledSecondaryContent,
  HomeContainer,
  StyledPhotoSection,
} from "./styles";

import { useState, useEffect } from "react";

import photo from "../../assets/photo.jpeg";

function HomeContent() {
  const [windowSize, setWindowSize] = useState(getWindowSize());

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <>
      <HomeContainer name="home">
        <section className="section">
          <StyledHomeContent>
            <h3>Olá! Eu sou</h3>
            <h1>Bruno Passos</h1>
            <p>{`> Front-end Developer`}</p>
          </StyledHomeContent>
          <StyledSecondaryContent>
            <h3>//veja meu perfil no GitHub:</h3>
            <p>
              <span className="firstSpan">const </span>
              <span>gitHubLink</span> ={" "}
              <span>
                <a href="https://github.com/brunopassos" target={"_blank"}>
                  "https://github.com/brunopassos"
                </a>
              </span>
            </p>
          </StyledSecondaryContent>
        </section>

        {windowSize.innerWidth > 850 && (
          <StyledPhotoSection>
            <img src={photo} alt="Minha foto" />
          </StyledPhotoSection>
        )}
      </HomeContainer>
    </>
  );
}

export default HomeContent;
